const COOKIES = {
  IS_USER_LOGGED: 'is_user_logged',
  IS_USER_NEW_PROMOBIT_ELIGIBLE: 'nxpDikrfl',
  OFFERS_VIEW_MODE: 'offers_view_mode',
};

export default COOKIES;
